/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightBagSelection } from "./FlightBagSelection";
import {
  FlightBagSelectionFromJSON,
  FlightBagSelectionFromJSONTyped,
  FlightBagSelectionToJSON,
  FlightBagSelectionToJSONTyped,
} from "./FlightBagSelection";

/**
 *
 * @export
 * @interface FlightBagSelectionRequest
 */
export interface FlightBagSelectionRequest {
  /**
   *
   * @type {Array<FlightBagSelection>}
   * @memberof FlightBagSelectionRequest
   */
  selections: Array<FlightBagSelection>;
}

/**
 * Check if a given object implements the FlightBagSelectionRequest interface.
 */
export function instanceOfFlightBagSelectionRequest(
  value: object
): value is FlightBagSelectionRequest {
  if (!("selections" in value) || value["selections"] === undefined)
    return false;
  return true;
}

export function FlightBagSelectionRequestFromJSON(
  json: any
): FlightBagSelectionRequest {
  return FlightBagSelectionRequestFromJSONTyped(json, false);
}

export function FlightBagSelectionRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBagSelectionRequest {
  if (json == null) {
    return json;
  }
  return {
    selections: (json["selections"] as Array<any>).map(
      FlightBagSelectionFromJSON
    ),
  };
}

export function FlightBagSelectionRequestToJSON(
  json: any
): FlightBagSelectionRequest {
  return FlightBagSelectionRequestToJSONTyped(json, false);
}

export function FlightBagSelectionRequestToJSONTyped(
  value?: FlightBagSelectionRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    selections: (value["selections"] as Array<any>).map(
      FlightBagSelectionToJSON
    ),
  };
}
